import { CircularProgress, Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";

export const SendingDialog = (props) => {

    const handleCloseWaitingDialog = (_, reason) => {
        console.log(reason);
        if (reason !== 'backdropClick') {
        }
    };
    
    return (
        <>
            <Dialog 
                open={props.show}
                onClose={handleCloseWaitingDialog}
                disableEscapeKeyDown={true}
                >
                <DialogTitle id="alert-dialog-title" >
                    {"Enviando información..."}
                </DialogTitle>
                <DialogContent sx={{
                                margin: 2,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}>
                    <CircularProgress />
                </DialogContent>
            </Dialog>   
        </>
    );
};
